const state= {
    safety_job: {},
    work_findings: [],
    wf_loading: false,
    safety_training: {}
};

const getters = {
    safetyJob: (state) => state.safety_job,
    workFindings : (state) => state.work_findings,
    wfLoading : (state) => state.wf_loading,
    safetyTraining: (state) => state.safety_training,
};

const actions = {
    // Safety Inspection Checklist
    async getSafetyInspectionChecklistItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-inspection-checklist`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getSafetyInspectionChecklistItem({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-inspection-checklist/${safety_job_id}`)
                .then(response => {
                    commit( 'setItem', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createSafetyInspectionItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/eme-safety-app/safety-inspection-checklist`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async updateSafetyInspectionItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/eme-safety-app/safety-inspection-checklist/${params.id}`, params.data)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteSafetyInspectionItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/safety-inspection-checklist`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async reportSafetyInspectionChecklistItem({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-inspection-checklist/report/${safety_job_id}`,
                {
                    responseType: 'blob',
                    headers: {
                        Accept: "application/json",
                    }
                }
            )
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    // Safety Job Status
    async updateSafetyStatus({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`/api/eme-safety-app/update-status-safety-joblist/${params.id}`, params.data)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

    // Work Findings
    async getWorkFindings({commit}, params){
        commit( 'setWfLoading', true );
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-inspection-checklist/work-finding`, {params:params})
                .then(response => {
                    commit( 'setWfLoading', false );
                    commit( 'setWorkFindings', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => {
                    commit( 'setWfLoading', false );
                    reject( error )
                });
        });
    },
    async saveWorkFindingItem({commit}, params){
        let formData = new FormData();
        formData.append('safety_job_id', params.data.safety_job_id);
        formData.append('description', params.data.description || '');
        formData.append('observations_non_compliances', params.data.observations_non_compliances || '');
        formData.append('risk_level', params.data.risk_level || '');
        formData.append('corrective_action', params.data.corrective_action || '');
        formData.append('preventive_action', params.data.preventive_action || '');
        formData.append('responsible_person_by_id', params.data.responsible_person_by_id || '');
        if(params.photos.length) {
            for(let i = 0; i < params.photos.length; i++){
                formData.append(`photos[${i}]`, params.photos[i]);
            }
        }

        let api = 'api/eme-safety-app/safety-inspection-checklist/work-finding';
        if(params.data.id)
            api += `/${params.data.id}`;

        return new Promise (( resolve, reject ) => {
            global.axios(api, {
                method: 'POST',
                data: formData,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteWorkFindingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/safety-inspection-checklist/work-finding`, {
                data: params
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },

    // Action Taken
    async saveActionTaken({commit}, params){
        let formData = new FormData();
        formData.append('safety_work_finding_id', params.data.safety_work_finding_id);
        formData.append('description', params.data.description || '');
        formData.append('status', params.data.status || '');
        formData.append('id', params.data.id || '');
        if(params.photos.length) {
            for(let i = 0; i < params.photos.length; i++){
                formData.append(`photos[${i}]`, params.photos[i]);
            }
        }

        return new Promise (( resolve, reject ) => {
            global.axios('api/eme-safety-app/safety-inspection-checklist/work-finding/action-taken', {
                method: 'POST',
                data: formData,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },

    // Checklist Entries
    async getSafetyCheckListGroupData({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-checklist-group/${safety_job_id}`)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    updateCheckListJob({commit}, params){
        return new Promise (( resolve, reject ) => {
          global.axios.put(`/api/eme-safety-app/safety-checklist-entries/multiple`, params)
              .then(response => {
                resolve( response )
              })
              .catch(error => reject( error ))
        });
    },
    async checklistEntriesFollowUp({commit}, params){
      return new Promise (( resolve, reject ) => {
        let formData = new FormData();
        formData.append('safety_remark_id', params.safety_remark_id || '');
        formData.append('description', params.data.description || '');

        if(params.action && params.action.photos && params.action.photos.length) {
            for( var i = 0; i < params.action.photos.length; i++ ){
                let photo = params.action.photos[i];
                formData.append('photos[' + i + ']', photo);
            }
        }

        global.axios(`/api/eme-safety-app/safety-checklist-entries/remarks/${params.id}`, {
            method: "POST",
            data: formData,
            headers: {
                Accept: "application/json",
            },
        }).then(response => {
                // commit('JobController/updateFollowUp',response.data.data, { root: true });
                resolve( response );
            }).catch(error => reject( error ))
        });
    },
    async getCheckListCalculated({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`/api/eme-safety-app/safety-checklist-entries/calculated/${params.id}`, {
                    method: "GET",
                    params: params.data,
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    resolve(response.data.data)
                })
                .catch(error => reject(error))
        });
    },

    // Attachments
    async deleteAttachments({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/eme-safety-app/attachments`, {
                    method: "DELETE",
                    data: { ids: params.ids },
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },

    // Permit To Work
    async getPermitToWorkItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/permit-to-work`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getPermitToWorkItem({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/permit-to-work/${safety_job_id}`)
                .then(response => {
                    commit( 'setItem', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getPermitToWorkItemNotCommit({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/permit-to-work/${safety_job_id}`)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createPermitToWorkItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/eme-safety-app/permit-to-work`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async updatePermitToWorkItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            if(params.photos) {
                for( var i = 0; i < params.photos.length; i++ ){
                    let photo = params.photos[i];
                    formData.append('photos[' + i + ']', photo);
                }
            }

            for (const [key, value] of Object.entries(params.data)) {
                let val = value ? value : '';
                formData.append(key, val);
            }

            global.axios.post(`api/eme-safety-app/permit-to-work/${params.id}`, formData)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deletePermitToWorkItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/permit-to-work`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async reportPermitToWorkItem({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/permit-to-work/report/${safety_job_id}`,
                {
                    responseType: 'blob',
                    headers: {
                        Accept: "application/json",
                    }
                }
            )
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    // Non Conformance Report
    async getNonConformanceReportItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/non-conformance-report`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getNonConformanceReportItem({commit}, safety_job_id){
        if(safety_job_id == '0' || safety_job_id == 0) {
            commit( 'setItem', {} );
            return;
        }
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/non-conformance-report/${safety_job_id}`)
                .then(response => {
                    commit( 'setItem', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async saveNonConformanceReportItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            if(params.attachment.photos) {
                for( var i = 0; i < params.attachment.photos.length; i++ ){
                    let photo = params.attachment.photos[i];
                    formData.append('photos[' + i + ']', photo);
                }
            }

            if(params.attachment.supporting_documents_file) {
                formData.append('supporting_documents_file', params.attachment.supporting_documents_file);
            }

            for (const [key, value] of Object.entries(params.data)) {
                let val = value ? value : '';
                if(key == 'supporting_documents' || key == 'follow_up_actions') {
                    val = JSON.stringify(value)
                }
                formData.append(key, val);
            }

            let api = 'api/eme-safety-app/non-conformance-report';
            if(params.data.id) api += `/${params.data.id}`

            global.axios.post(api, formData)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteNonConformanceReportItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/non-conformance-report`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async reportNonConformanceReportItem({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/non-conformance-report/report/${safety_job_id}`,
                {
                    responseType: 'blob',
                    headers: {
                        Accept: "application/json",
                    }
                }
            )
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    // Safety Induction Training
    async getSafetyInductionTrainingItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-induction-training`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getSafetyInductionTrainingItem({commit}, id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-induction-training/${id}`)
                .then(response => {
                    commit( 'setItemInductionTraining', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createSafetyInductionTrainingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/eme-safety-app/safety-induction-training`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async updateSafetyInductionTrainingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            if(params.photos) {
                for( var i = 0; i < params.photos.length; i++ ){
                    let photo = params.photos[i];
                    formData.append('photos[' + i + ']', photo);
                }
            }

            for (const [key, value] of Object.entries(params.data)) {
                let val = value ? value : '';
                if(key == 'topics') {
                    val = JSON.stringify(value)
                }
                formData.append(key, val);
            }

            global.axios.post(`api/eme-safety-app/safety-induction-training/${params.id}`, formData)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async updateSafetyInductionTrainingStatus({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            for (const [key, value] of Object.entries(params.data)) {
                let val = value ? value : '';
                let keyPush = key
                if(key == 'photo_signatures') {
                    keyPush = 'photo_signatures[0]'
                }
                formData.append(keyPush, val);
            }

            global.axios.post(`api/eme-safety-app/safety-induction-training/update-status/${params.id}`, formData)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteSafetyInductionTrainingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/safety-induction-training`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async reportSafetyInductionTrainingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-induction-training/report/${params.id}`,
                {
                    params: params.data,
                    responseType: 'blob',
                    headers: {
                        Accept: "application/json",
                    }
                }
            )
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async registerWorker({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            for (const [key, value] of Object.entries(params)) {
                let val = value ? value : '';
                let keyPush = key
                if(key == 'signatures') {
                    keyPush = 'signatures[0]'
                }
                formData.append(keyPush, val);
            }
            global.axios.post(`api/eme-safety-app/safety-induction-training/register`, formData)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async dowloadQRCodeSafetyInductionTraining({commit}, id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/safety-induction-training/qr-code/${id}`)
                .then(response => {
                    resolve( response.data );
                })
                .catch(error => reject( error ));
        });
    },

    // Safety Toolbox Meeting
    async getSafetyToolboxMeetingItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/toolbox-meeting`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getSafetyToolboxMeetingItem({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/toolbox-meeting/${safety_job_id}`)
                .then(response => {
                    commit( 'setItem', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async createSafetyToolboxMeetingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/eme-safety-app/toolbox-meeting`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async updateSafetyToolboxMeetingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            if(params.photos) {
                for( var i = 0; i < params.photos.length; i++ ){
                    let photo = params.photos[i];
                    formData.append('photos[' + i + ']', photo);
                }
            }

            for (const [key, value] of Object.entries(params.data)) {
                let val = value ? value : '';
                if(key == 'topics' || key == 'locations') {
                    val = JSON.stringify(value)
                }
                formData.append(key, val);
            }

            global.axios.post(`api/eme-safety-app/toolbox-meeting/${params.id}`, formData)
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteSafetyToolboxMeetingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/toolbox-meeting`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    async reportSafetyToolboxMeetingItem({commit}, safety_job_id){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/toolbox-meeting/report/${safety_job_id}`,
                {
                    responseType: 'blob',
                    headers: {
                        Accept: "application/json",
                    }
                }
            )
                .then(response => {
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },

    //Workers
    async getworkerItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/workers`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },

    async createWorkerForToolboxMeetingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/eme-safety-app/toolbox-meeting/worker`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async updateWorkerForToolboxMeetingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/eme-safety-app/toolbox-meeting/worker/${params.id}`, params)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteWorkerForToolboxMeetingItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/toolbox-meeting/worker`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

    async saveWorkerItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            let api = 'api/eme-safety-app/workers';
            if(params.id) api += `/${params.id}`

            global.axios(api, {
                method: params.id ? 'PUT' : 'POST',
                data: params.data,
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteWorkerItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/workers`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },

    async importWorkerItems({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.fileImport);
            global.axios.post(`api/eme-safety-app/workers/import`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },

    // Activity Logs
    async getActivityLogs({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`/api/eme-safety-app/activity-logs`, { params: params })
                .then(response => {
                    resolve(response)
                })
                .catch(error => reject(error));
        });
    },

    // API: new for Safety App
    async getProjects({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/project`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getCompanies({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/company`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getUserDuties({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/user-duty`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getLocations({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/location`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },

    // Safety Suppliers
    async getSafetySupplierItems({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/eme-safety-app/project-company`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async saveSafetySupplierItem({commit}, params){
        return new Promise (( resolve, reject ) => {

            let api = 'api/eme-safety-app/project-company';
            if(params.id) api += `/${params.id}`

            global.axios(api, {
                method: params.id ? 'PUT' : 'POST',
                data: params.data,
                headers: {
                    Accept: "application/json",
                },
            })
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async deleteSafetySupplierItem({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.delete(`api/eme-safety-app/project-company`, {
                data: {
                    ids: params
                }
            })
            .then(response => {
                resolve( response );
            })
            .catch(error => reject( error ));
        });
    },
    // Location
    async getListLocations({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/eme-safety-app/location-config`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async checkExistingPostalCode({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/eme-safety-app/location-config/check-existing-postal-code`, params)
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    // Comment For Permit To Work
    async saveCommentPTW({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.put(`api/eme-safety-app/permit-to-work/comment/${params.id}`, params.data)
            .then(response => {
                resolve( response.data.data );
            })
            .catch(error => reject( error ));
        });
    },
    async importSafetyLocations({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('file_import', params.fileImport);
            global.axios.post(`/api/contracts/${params.contract_id}/properties/import-safety`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
    async exportWorkerItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/eme-safety-app/workers/export`, { 
                responseType: 'blob',
                params: params 
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async importSafetyUsers({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import', params.fileImport);
            formData.append('contract_id', params.contract_id);
            global.axios.post(`/api/eme-safety-app/import-users`, formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
    async exportSafetyInspections({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/eme-safety-app/safety-inspection-checklist/export`, { 
                responseType: 'blob',
                params: params 
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async exportPermitToWork({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/eme-safety-app/permit-to-work/export`, {
                responseType: 'blob',
                params: params
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async exportNonConformanceReports({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/eme-safety-app/non-conformance-report/export`, {
                responseType: 'blob',
                params: params
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
    async exportSafetyToolboxMeetings({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/eme-safety-app/toolbox-meeting/export`, {
                responseType: 'blob',
                params: params
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
};

const mutations = {
    setItem(state, data) {
        state.safety_job = data;
    },
    setWorkFindings (state, data) {
        state.work_findings = data;
    },
    setWfLoading (state, data) {
        state.wf_loading = data;
    },
    setItemInductionTraining(state, data) {
        state.safety_training = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
